import { type ProductAPI, ProductCommodityGroupAPI } from '~/api/Catalog';
import type { CartItem, CartItemOffer } from '~/stores/CartStore/interfaces';
import { Product } from '~/stores/CategoriesStore/Product';
import { isProductBundle } from '~/types/Product';

// TODO: Remove this function and use the Product class directly
/**
 * Converts a cart item to a product
 * @param cartItem - The cart item to convert
 * @returns The product
 */
export const convertCartItemToProduct = (cartItem: CartItem): Product => {
  if (isProductBundle(cartItem)) {
    return cartItem;
  }

  const offer = cartItem as CartItemOffer;

  const imagesAPI =
    offer.images.length > 0
      ? offer.images.map((url) => ({ url, thumb: url }))
      : null;

  const previewImageUrl = offer.images[0] || offer.previewImageThumb || '';
  const previewImageThumbUrl = offer.previewImageThumb || offer.images[0] || '';

  const productAPI: ProductAPI = {
    id: offer.productId || offer.id,
    categoryId: offer.categoryId || -1,
    categoryName: offer.categoryName || '',
    categorySlug: offer.categoryName?.toLowerCase().replace(/\s+/g, '-') || '',
    commodityGroup: offer.commodityGroup || {
      id: 0,
      name: ProductCommodityGroupAPI.GROCERY,
    },
    description: offer.description || null,
    discountPrice: offer.discountPrice || null,
    minBasketDiscountPrice: null,
    minBasketDiscountQuantity: null,
    slug: offer.slug || offer.productSlug || '',
    images: imagesAPI,
    isFavourite: false,
    name: offer.name,
    offerProperties: null,
    offers: [
      {
        active: true,
        backorderLeadTime: offer.backorderLeadTime || 0,
        bundleId: offer.bundleId || null,
        code: offer.sku,
        description: offer.description || null,
        discountPrice: offer.discountPrice || null,
        id: offer.id,
        images: imagesAPI,
        isBackorderAvailable: offer.isBackorderAvailable,
        minBasketDiscountPrice: null,
        minBasketDiscountQuantity: null,
        multibuyPriceLevels: offer.multibuyPriceLevels || null,
        name: offer.name,
        price: offer.price || null,
        productId: offer.productId || offer.id,
        properties: [],
        sellable: offer.sellable || 0,
        sellableWarehouses: offer.sellableWarehouses || {},
        salesQuantity: 0,
        createdAt: '',
        updatedAt: '',
        metadataTitle: offer.metadataTitle || null,
        metadataDescription: offer.metadataDescription || null,
        productSlug: offer.productSlug || offer.slug || undefined,
      },
    ],
    parentCategoryId: offer.parentCategoryId || -1,
    parentCategoryName: offer.categoryName || '',
    previewImage: previewImageUrl
      ? { url: previewImageUrl, thumb: previewImageThumbUrl }
      : { url: '', thumb: '' },
    previewImageThumb: previewImageThumbUrl
      ? { url: previewImageThumbUrl, thumb: previewImageThumbUrl }
      : { url: '', thumb: '' },
    price: offer.price || null,
    sellable: offer.sellable || 0,
    sellableWarehouses: offer.sellableWarehouses || {},
    status: null,
    code: offer.sku,
    isBackorderAvailable: offer.isBackorderAvailable || null,
    backorderLeadTime: offer.backorderLeadTime || null,
    multibuyPriceLevels: offer.multibuyPriceLevels || null,
    variants: [],
    salesQuantity: 0,
    createdAt: '',
    updatedAt: '',
    ratingAverage: offer.ratingAverage || undefined,
    ratingMarksCount: offer.ratingMarksCount || undefined,
    sortingCategoryPosition: 0,
    productType: 'product',
    metadataTitle: offer.metadataTitle || null,
    metadataDescription: offer.metadataDescription || null,
    isBought: false,
  };

  return new Product(productAPI);
};
